import styled from "styled-components"
import colors from "styles/colors"

export const Wrapper = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 28px 1fr 28px;
  margin-top: 20px;
  margin-right: 15px;
  width: 100%;
`

export const Box = styled.div`
  width: 28px;
`

export const PageLabel = styled.div`
  color: ${colors.gray};
  font-size: 14px;
  font-weight: 600;
  justify-self: center;
  text-align: center;
`
